import React from 'react';
import {inject, observer} from 'mobx-react';

import LivePageViewPicker from '../../components/common/view-picker';
import {
    SportsRightPanelTabs,
} from './components';


const PrematchRightPanel = ({store, isLive}) => {
    const viewSize = store.site.status.viewSize;

    return viewSize === 'desktop' ? (
        <div className="js_coupons-section coupons__section">
            {isLive && <LivePageViewPicker/>}
            <SportsRightPanelTabs/>
        </div>
    ) : null;
};

export default inject('store')(observer(PrematchRightPanel));